import { type MaybeRefOrGetter, toValue } from "vue";

import i18n from "@/plugins/i18n";
import { RouteRedispatchState, RouteStatus } from "@/constants/trip";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto";
import { useBaseView } from "@/composables/useBaseView";

import type { BrokerUpdateValidationContext, DisableRule } from "@/types/validation";

const t = i18n.global.t;

export function useBrokerUpdate() {
  const { hasAccess } = useBaseView();

  function createBrokerUpdateDisableRules(context: MaybeRefOrGetter<BrokerUpdateValidationContext>): DisableRule[] {
    const {
      sendUpdates,
      routeStatus,
      redispatch,
      isTechnicalPartial,
      isTravelOrderInProgress,
      isCheckCallDismissed,
    } = toValue(context);

    return [
      {
        disabled: !hasAccess(DispatcherPermissionValue.BrokerUpdatesEdit),
        reasons: [t("permission.create-broker-update")],
      },
      {
        disabled: !sendUpdates,
        reasons: [t("updates.disabled-reason.broker-updates-off")],
      },
      {
        disabled: routeStatus === RouteStatus.cancelled,
        reasons: [t("updates.disabled-reason.route-cancelled")],
      },
      {
        disabled: routeStatus === RouteStatus.planned,
        reasons: [t("updates.disabled-reason.route-planned")],
      },
      {
        disabled: redispatch === RouteRedispatchState.needed,
        reasons: [t("updates.disabled-reason.redispatch-needed")],
      },
      {
        disabled: Boolean(isTechnicalPartial) && !isTravelOrderInProgress,
        reasons: [t("updates.disabled-reason.travel-order-not-in-progress")],
      },
      {
        disabled: Boolean(isCheckCallDismissed),
        reasons: [t("updates.disabled-reason.check-call-dismissed")],
      },
    ];
  }

  return { createBrokerUpdateDisableRules };
}
